import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { FaFilePdf, FaRegCopy } from "react-icons/fa";
import { toast } from "react-toastify";
import { useNegotiation } from "../contexts/NegotiationContext";
import { usePrivate } from "../contexts/PrivateInfoContext";
import { pdfService } from "../services/PdfService";
import { carregaNegociacaoCobrancas } from "../services/requests/getChargesInfo";
import { extraiCodigoBarras, montaLinhaDigitavel } from "../utils/CodigoBarrasBoleto";

function copiaFallback(texto) {
  // navigator.clipboard não existe fora de HTTPS e em webviews antigas de Android
  const area = document.createElement("textarea");
  area.value = texto;
  area.setAttribute("readonly", "");
  area.style.position = "absolute";
  area.style.left = "-9999px";

  document.body.appendChild(area);
  area.select();
  const copiou = document.execCommand("copy");
  document.body.removeChild(area);

  if (!copiou) throw new Error("execCommand copy falhou");
}

function DownloadBoletoDialog({ close, atualizarDados }) {
  const { infoFinanceira } = usePrivate();
  const { boletoData } = useNegotiation();
  const [linhaDigitavel, setLinhaDigitavel] = useState(() => montaLinhaDigitavel(extraiCodigoBarras(boletoData)));

  // se a resposta da negociação não trouxe o código de barras, busca no boleto já gravado
  useEffect(() => {
    const negociacao_id = boletoData?.[0]?.negociacao_id;
    if (linhaDigitavel || !negociacao_id) return;

    let ativo = true;

    async function buscaCodigoBarras() {
      try {
        const data = await carregaNegociacaoCobrancas(negociacao_id);
        if (ativo) setLinhaDigitavel(montaLinhaDigitavel(extraiCodigoBarras(data?.boletos)));
      } catch (error) {
        console.log(error);
      }
    }
    buscaCodigoBarras();

    return () => {
      ativo = false;
    };
  }, [boletoData, linhaDigitavel]);

  async function copiarLinhaDigitavel() {
    // copia formatado, igual ao que aparece na tela e ao app do credor
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(linhaDigitavel);
      else copiaFallback(linhaDigitavel);

      toast.success("Código de barras copiado!");
    } catch (error) {
      console.log(error);
      toast.warn("Não foi possível copiar. Selecione o número acima e copie manualmente.");
    }
  }

  return (
    <Dialog
      visible
      //showHeader={false}
      onHide={() => close()}
      header={"Negociação realizada com Sucesso."}
      style={{
        minHeigth: "30vw",
        minWidth: "20vw",
        textAlign: "center",
        borderRadius: "0.75rem",
      }}
    >
      <div className="grid gap-2 negotiationButton p-[2vw] text-left text-slate-700">
        {/* <h5>Negociação realizada com Sucesso.</h5> */}
        <div
          className="p-2 border-2 border-sky-900 bg-slate-100 rounded-xl text-slate-900 
        gap-1 grid font-semibold"
        >
          <h7>
            *Para obter os próximos boletos, acesse o link:
            <a
              target="_blank"
              href={window.location.origin}
              rel="noreferrer"
              className="text-blue-700 underline cursor-pointer"
            >
              {window.location.origin}
            </a>{" "}
            na opção 'Ver Negociações'
          </h7>
          <br />
          <h7>*Você receberá lembretes através de e-mail e sms dos próximos vencimentos.</h7>
          <br />
          <h7>
            *Gostaria de alterar seus dados?{" "}
            <span onClick={() => atualizarDados()} className="text-blue-700 underline cursor-pointer">
              Clique aqui
            </span>
          </h7>
          <br />
          <h7>
            *Mais informações:{" "}
            <a
              target="_blank"
              href="https://wa.me/5511996383405"
              rel="noreferrer"
              className="text-emerald-600 underline cursor-pointer"
            >
              {" "}
              11 99638-3405
            </a>
          </h7>
          <br />
        </div>
        <h6 className="font-bold text-center mt-[2vh]">Baixe o primeiro boleto clicando abaixo</h6>
        {/* <div className="flex p-[1vh] justify-center">
          <i className="text-6xl">
            <GrDocumentPdf className="text-red-600"></GrDocumentPdf>
          </i>
        </div> */}
        <div className="mt-[1vh]">
          <button
            className="bg-[#001d74] w-full h-[6vh] text-slate-50 p-2
                    hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                    hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                    disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 disabled:hover:shadow-none
                    text-[2.5vh] font-lato font-bold disabled:bg-[#001d74]/70 rounded-md 
                    justify-center flex gap-2 items-center"
            onClick={() => {
              pdfService(boletoData);
            }}
            type="button"
          >
            <FaFilePdf className="text-red-500"></FaFilePdf>
            <span>Baixar Boleto</span>
          </button>
        </div>
        {linhaDigitavel && (
          <div className="mt-[2vh] grid gap-2">
            <h6 className="font-bold text-center">Ou pague pelo código de barras</h6>
            <p
              className="p-2 border-2 border-slate-400 bg-slate-50 rounded-md text-slate-900
                      font-mono text-[1.9vh] text-center break-all select-all"
            >
              {linhaDigitavel}
            </p>
            <button
              className="border-2 border-[#001d74] text-[#001d74] w-full h-[6vh] p-2
                      hover:bg-[#001d74] hover:text-slate-50 transition duration-300
                      text-[2.5vh] font-lato font-bold rounded-md
                      justify-center flex gap-2 items-center"
              onClick={() => copiarLinhaDigitavel()}
              type="button"
            >
              <FaRegCopy />
              <span>Copiar código de barras</span>
            </button>
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default DownloadBoletoDialog;